import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { TrendingUpIcon } from 'lucide-react';
export function Navbar() {
  const location = useLocation();
  const isActive = (path: string) => location.pathname === path;
  return <nav className="bg-slate-900 text-white border-b border-slate-800" data-id="element-51">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-52">
        <div className="flex items-center justify-between h-16" data-id="element-53">
          <Link to="/" className="flex items-center gap-2 font-bold text-xl hover:text-blue-400 transition-colors" data-id="element-54">
            <TrendingUpIcon size={28} className="text-blue-400" data-id="element-55" />
            <span data-id="element-56">CryptoTopReviews</span>
          </Link>

          <div className="flex items-center gap-1" data-id="element-57">
            <Link to="/" className={`px-4 py-2 rounded-lg transition-colors ${isActive('/') ? 'bg-slate-800 text-white' : 'text-slate-300 hover:text-white hover:bg-slate-800'}`} data-id="element-58">
              Home
            </Link>
            <Link to="/cryptocurrencies" className={`px-4 py-2 rounded-lg transition-colors ${isActive('/cryptocurrencies') ? 'bg-slate-800 text-white' : 'text-slate-300 hover:text-white hover:bg-slate-800'}`} data-id="element-59">
              Cryptocurrencies
            </Link>
            <Link to="/exchanges" className={`px-4 py-2 rounded-lg transition-colors ${isActive('/exchanges') ? 'bg-slate-800 text-white' : 'text-slate-300 hover:text-white hover:bg-slate-800'}`} data-id="element-60">
              Exchanges
            </Link>
          </div>
        </div>
      </div>
    </nav>;
}